<div *ngIf="dados" class="document-preview">
  <img src="assets/img/header_sg.jpg" class="doc-header-img" alt="Cabeçalho">

  <h2 class="doc-center">UNIVERSIDADE ESTADUAL DE CAMPINAS</h2>
  <h3 class="doc-center">{{ dados.dadosConcurso.nomeUnidade }}</h3>
  <h3 class="doc-center">{{ tituloDocumentoFormatado }}</h3>
  <p class="doc-center"><strong>(Proc. nº {{ dados.dadosConcurso.processoSigad }})</strong></p>

  <app-texto-com-placeholders
    [texto]="dados.textoIntrodutorio"
    [campos]="campos"
    (camposChange)="onCamposChange($event)">
  </app-texto-com-placeholders>

  <mat-form-field *ngIf="hasCampo('conteudo') && tipoRecurso !== 'ALTERACAO_CALENDARIO_FASE2'" appearance="outline" class="full-width">
    <mat-label>{{ tipoRecurso === 'COMISSAO_CALENDARIO' ? 'Calendário de Provas' : 'Onde consta' }}</mat-label>
    <textarea matInput rows="3" cdkTextareaAutosize [(ngModel)]="campos['conteudo']" (ngModelChange)="onCampoChange('conteudo', $event)"></textarea>
  </mat-form-field>

  <ng-container *ngIf="hasCampo('conteudo') && tipoRecurso === 'ALTERACAO_CALENDARIO_FASE2'">
    <h4><strong>FASE II</strong></h4>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Calendário de Provas</mat-label>
      <textarea matInput rows="5" cdkTextareaAutosize [(ngModel)]="campos['conteudo']" (ngModelChange)="onCampoChange('conteudo', $event)"></textarea>
    </mat-form-field>
  </ng-container>

  <mat-form-field *ngIf="hasCampo('conteudo2')" appearance="outline" class="full-width">
    <mat-label>Constar</mat-label>
    <textarea matInput rows="3" cdkTextareaAutosize [(ngModel)]="campos['conteudo2']" (ngModelChange)="onCampoChange('conteudo2', $event)"></textarea>
  </mat-form-field>

  <p *ngIf="tipoRecurso === 'RETIFICACAO_EDITAL'">Os demais itens permanecem inalterados.</p>

  <ng-container *ngIf="dados.candidatos.length > 0 && tipoRecurso === 'TERMO_ENCERRAMENTO'">
    <h4>1. {{ candidatosPorCategoria('INSCRITO').length <= 1 ? 'Inscrição' : 'Inscrições' }}, conforme item 3 do edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th></tr></thead>
      <tbody><tr *ngFor="let c of candidatosPorCategoria('INSCRITO')"><td>{{ c.inscricaoId }}</td><td>{{ c.nome | uppercase }}</td></tr></tbody>
    </table>

    <h4 style="margin-top:1.5em">2. {{ candidatosPorCategoria('CONDICAO_ESPECIAL').length <= 1 ? 'Solicitação' : 'Solicitações' }} de Condições Especiais {{ candidatosPorCategoria('CONDICAO_ESPECIAL').length <= 1 ? 'recebida' : 'recebidas' }} conforme item 4 do edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th></tr></thead>
      <tbody><tr *ngFor="let c of candidatosPorCategoria('CONDICAO_ESPECIAL')"><td>{{ c.inscricaoId }}</td><td>{{ c.nome | uppercase }}</td></tr></tbody>
    </table>
    <p class="doc-info">Informo que o(s) candidato(s) listado(s) acima inseriu/ram no sistema de concursos o(s) laudo(s) para atendimento do item 4.1 do edital. Esse(s) laudo(s) deve(m) ser consultado(s) para os fins a que se destina(m) no próprio sistema, pois ele(s) não instruirá/ão o processo administrativo.</p>

    <h4 style="margin-top:1.5em">3. {{ candidatosPorCategoria('LACTANTE').length <= 1 ? 'Solicitação' : 'Solicitações' }} de Lactantes {{ candidatosPorCategoria('LACTANTE').length <= 1 ? 'recebida' : 'recebidas' }} conforme item 5 do edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th></tr></thead>
      <tbody><tr *ngFor="let c of candidatosPorCategoria('LACTANTE')"><td>{{ c.inscricaoId }}</td><td>{{ c.nome | uppercase }}</td></tr></tbody>
    </table>

    <h4 style="margin-top:1.5em">4. {{ candidatosPorCategoria('PCD').length <= 1 ? 'Inscrição' : 'Inscrições' }} como Pessoa com Deficiência {{ candidatosPorCategoria('PCD').length <= 1 ? 'recebida' : 'recebidas' }} conforme item 6 do edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th></tr></thead>
      <tbody><tr *ngFor="let c of candidatosPorCategoria('PCD')"><td>{{ c.inscricaoId }}</td><td>{{ c.nome | uppercase }}</td></tr></tbody>
    </table>
    <p class="doc-info">Informo que o(s) candidato(s) listado(s) acima inseriu/ram no sistema de concursos o(s) laudo(s) para atendimento do item 6.1.4 do edital. Esse(s) laudo(s) deve(m) ser consultado(s) para os fins a que se destina(m) no próprio sistema, pois ele(s) não instruirá/ão o processo administrativo.</p>
  </ng-container>

  <ng-container *ngIf="dados.candidatos.length > 0 && tipoRecurso === 'DEFERIMENTO_INSCRICOES'">
    <h4>1. {{ candidatosPorCategoria('INSCRITO').length <= 1 ? 'Inscrição' : 'Inscrições' }}, conforme item 3.8 do Edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th><th>Deferido/Indeferido</th><th>Justificativa</th></tr></thead>
      <tbody><tr *ngFor="let c of candidatosPorCategoria('INSCRITO')"><td>{{ c.inscricaoId }}</td><td>{{ c.nome | uppercase }}</td><td>{{ c.status }}</td><td>{{ c.justificativa }}</td></tr></tbody>
    </table>

    <h4 style="margin-top:1.5em">2. {{ candidatosPorCategoria('CONDICAO_ESPECIAL').length <= 1 ? 'Solicitação' : 'Solicitações' }} de Condições Especiais, conforme item 4.6 do Edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th><th>Deferido/Indeferido</th><th>Justificativa</th></tr></thead>
      <tbody><tr *ngFor="let c of candidatosPorCategoria('CONDICAO_ESPECIAL')"><td>{{ c.inscricaoId }}</td><td>{{ c.nome | uppercase }}</td><td>{{ c.status }}</td><td>{{ c.justificativa }}</td></tr></tbody>
    </table>

    <h4 style="margin-top:1.5em">3. {{ candidatosPorCategoria('LACTANTE').length <= 1 ? 'Solicitação' : 'Solicitações' }} de Lactantes, conforme item 5.5 do Edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th><th>Deferido/Indeferido</th><th>Justificativa</th></tr></thead>
      <tbody><tr *ngFor="let c of candidatosPorCategoria('LACTANTE')"><td>{{ c.inscricaoId }}</td><td>{{ c.nome | uppercase }}</td><td>{{ c.status }}</td><td>{{ c.justificativa }}</td></tr></tbody>
    </table>

    <h4 style="margin-top:1.5em">4. {{ candidatosPorCategoria('PCD').length <= 1 ? 'Inscrição' : 'Inscrições' }} como Pessoa com Deficiência, conforme item 6.4 do Edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th><th>Deferido/Indeferido</th><th>Justificativa</th></tr></thead>
      <tbody><tr *ngFor="let c of candidatosPorCategoria('PCD')"><td>{{ c.inscricaoId }}</td><td>{{ c.nome | uppercase }}</td><td>{{ c.status }}</td><td>{{ c.justificativa }}</td></tr></tbody>
    </table>
  </ng-container>

  <ng-container *ngIf="dados.recursos.length > 0 && tipoRecurso === 'RESULTADO_RECURSO_INSCRICOES'">
    <h4>1. Resultado da Análise de {{ dados.recursos.length <= 1 ? 'Recurso' : 'Recursos' }} contra o indeferimento de {{ dados.recursos.length <= 1 ? 'inscrição' : 'inscrições' }}, conforme item 3.9.1.1 do Edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th><th>Deferido/Indeferido</th><th>Justificativa</th></tr></thead>
      <tbody><tr *ngFor="let r of dados.recursos; let i = index"><td>{{ r.inscricaoId }}</td><td>{{ r.nome | uppercase }}</td><td>{{ r.resultado }}</td><td><textarea rows="2" class="cell-input" [(ngModel)]="dados.recursos[i].justificativa" (ngModelChange)="emitir()" (keydown.enter)="$event.stopPropagation()"></textarea></td></tr></tbody>
    </table>

    <h4 style="margin-top:1.5em">2. Resultado da Análise de {{ dados.recursos.length <= 1 ? 'Recurso' : 'Recursos' }} contra o indeferimento das solicitações de Condições Especiais, conforme item 4.6.1.1 do Edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th><th>Deferido/Indeferido</th><th>Justificativa</th></tr></thead>
      <tbody></tbody>
    </table>

    <h4 style="margin-top:1.5em">3. Resultado da Análise de {{ dados.recursos.length <= 1 ? 'Recurso' : 'Recursos' }} contra o indeferimento das solicitações de Lactantes, conforme item 5.5.1.1 do Edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th><th>Deferido/Indeferido</th><th>Justificativa</th></tr></thead>
      <tbody></tbody>
    </table>

    <h4 style="margin-top:1.5em">4. Resultado da Análise de {{ dados.recursos.length <= 1 ? 'Recurso' : 'Recursos' }} contra o indeferimento das inscrições como Pessoa com Deficiência, conforme item 6.4.2 do Edital de abertura:</h4>
    <table>
      <thead><tr><th>Nº de inscrição</th><th>Nome Completo</th><th>Deferido/Indeferido</th><th>Justificativa</th></tr></thead>
      <tbody></tbody>
    </table>
  </ng-container>

  <ng-container *ngIf="tipoRecurso === 'RESULTADO_FINAL' && dados.candidatos.length > 0">
    <h4 style="margin-top: 2em">Relação de Aprovados – Ampla Concorrência:</h4>
    <ng-container *ngFor="let cand of candidatosPorCategoria('AMPLA')">
      <p><strong>{{ cand.status }} Classificado: {{ cand.inscricaoId }} - {{ cand.nome | uppercase }}</strong></p>
      <table class="equal-cols">
        <thead><tr><th>Provas</th><th *ngFor="let ex of examinadores">Prof(a). Dr(a). {{ nomeExam(ex) }}<span *ngIf="examMarkers[ex]"> {{ examMarkers[ex] }}</span></th></tr></thead>
        <tbody>
          <tr *ngFor="let prova of provas">
            <td class="col-candidato">{{ prova }}</td>
            <td *ngFor="let ex of examinadores">{{ getNota(prova, cand.inscricaoId, ex) }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>

    <h4 *ngIf="candidatosPorCategoria('PCD').length > 0" style="margin-top:1.5em">Relação de Aprovados – PcD:</h4>
    <ng-container *ngFor="let cand of candidatosPorCategoria('PCD')">
      <p><strong>{{ cand.status }} Classificado: {{ cand.inscricaoId }} - {{ cand.nome | uppercase }}</strong></p>
      <table class="equal-cols">
        <thead><tr><th>Provas</th><th *ngFor="let ex of examinadores">Prof(a). Dr(a). {{ nomeExam(ex) }}<span *ngIf="examMarkers[ex]"> {{ examMarkers[ex] }}</span></th></tr></thead>
        <tbody>
          <tr *ngFor="let prova of provas">
            <td class="col-candidato">{{ prova }}</td>
            <td *ngFor="let ex of examinadores">{{ getNota(prova, cand.inscricaoId, ex) }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>

    <div *ngIf="legendaSubstituicoes.length > 0" style="margin-top:16px;font-size:8pt;">
      <p *ngFor="let s of legendaSubstituicoes" style="margin:2px 0;">{{ s.marker }} Prof(a). Dr(a). {{ s.nome }} em substituição ao(à) Prof(a). Dr(a). {{ s.substituido }}</p>
    </div>

    <h4 style="margin-top:1.5em">Classificação Geral</h4>
    <table>
      <thead><tr><th>Nº Inscrição</th><th>Nome do Candidato</th><th>Classificação</th></tr></thead>
      <tbody>
        <tr *ngFor="let cand of candidatosPorCategoria('AMPLA')"><td>{{ cand.inscricaoId }}</td><td>{{ cand.nome | uppercase }}</td><td>{{ cand.status }}</td></tr>
      </tbody>
    </table>

    <h4 *ngIf="candidatosPorCategoria('PCD').length > 0" style="margin-top:1.5em">Classificação PcD</h4>
    <table *ngIf="candidatosPorCategoria('PCD').length > 0">
      <thead><tr><th>Nº Inscrição</th><th>Nome do Candidato</th><th>Classificação</th></tr></thead>
      <tbody><tr *ngFor="let cand of candidatosPorCategoria('PCD')"><td>{{ cand.inscricaoId }}</td><td>{{ cand.nome | uppercase }}</td><td>{{ cand.status }}</td></tr></tbody>
    </table>
  </ng-container>

  <ng-container *ngIf="tipoRecurso === 'COMISSAO_CALENDARIO'">
    <h4>CANDIDATOS INSCRITOS</h4>
    <p *ngFor="let c of dados.candidatos">{{ c.inscricaoId }} - {{ c.nome | uppercase }}</p>

    <h4 style="margin-top:1.5em">COMISSÃO JULGADORA</h4>
    <p><strong>Titulares:</strong></p>
    <ng-container *ngFor="let m of dados.comissao">
      <p *ngIf="m.papel === 'Titular' || m.papel === 'Presidente'">{{ m.nome }}<span *ngIf="m.presidente"> (Presidente)</span></p>
    </ng-container>
    <p><strong>Suplentes:</strong></p>
    <ng-container *ngFor="let m of dados.comissao">
      <p *ngIf="m.papel === 'Suplente'">{{ m.nome }}</p>
    </ng-container>

    <h4 style="margin-top:1.5em">CALENDÁRIO DE PROVAS DO CONCURSO</h4>
    <table class="calendario-table">
      <colgroup><col style="width:25%"><col style="width:20%"><col style="width:15%"><col style="width:40%"></colgroup>
      <thead><tr><th>PROVA(S) FASE I</th><th>DATA PARA REALIZAÇÃO DA PROVA</th><th>HORÁRIO</th><th>LOCAL</th></tr></thead>
      <tbody>
        <tr *ngFor="let n of provasFase1"><td><input matInput [(ngModel)]="campos['fase1_prova' + n + '_nome']" (ngModelChange)="emitir()"></td><td><input matInput [(ngModel)]="campos['fase1_prova' + n + '_data']" (ngModelChange)="emitir()"></td><td><input matInput [(ngModel)]="campos['fase1_prova' + n + '_horario']" (ngModelChange)="emitir()"></td><td><input matInput [(ngModel)]="campos['fase1_prova' + n + '_local']" (ngModelChange)="emitir()"></td></tr>
      </tbody>
    </table>

    <p><strong>Divulgação do resultado da Fase I:</strong>
      <span class="inline-input-wrapper">
        <input class="inline-input" placeholder="Data e hora" [(ngModel)]="campos['divulgacao_fase1']" (ngModelChange)="emitir()" style="text-align:center;min-width:140px;">
      </span>
      <br/>Disponíveis no endereço <em>"inscricoes.unicamp.br"</em>
    </p>

    <table class="calendario-table">
      <colgroup><col style="width:25%"><col style="width:20%"><col style="width:15%"><col style="width:40%"></colgroup>
      <thead><tr><th>PROVAS FASE II</th><th>DATA PARA REALIZAÇÃO DA PROVA</th><th>HORÁRIO</th><th>LOCAL</th></tr></thead>
      <tbody>
        <tr *ngFor="let n of provasFase2"><td><input matInput [(ngModel)]="campos['fase2_prova' + n + '_nome']" (ngModelChange)="emitir()"></td><td><input matInput [(ngModel)]="campos['fase2_prova' + n + '_data']" (ngModelChange)="emitir()"></td><td><input matInput [(ngModel)]="campos['fase2_prova' + n + '_horario']" (ngModelChange)="emitir()"></td><td><input matInput [(ngModel)]="campos['fase2_prova' + n + '_local']" (ngModelChange)="emitir()"></td></tr>
      </tbody>
    </table>

    <p>O calendário poderá ser alterado conforme a quantidade de candidatos presentes.</p>
  </ng-container>

  <p *ngIf="tipoRecurso === 'RESULTADO_RECURSO_COMISSAO' && dados.recursos.length > 0"><strong>Resultado de {{ dados.recursos.length <= 1 ? 'Recurso' : 'Recursos' }} contra a composição da Comissão Julgadora</strong></p>

  <table *ngIf="dados.recursos.length > 0 && tipoRecurso === 'RESULTADO_RECURSO_COMISSAO'">
    <thead>
      <tr>
        <th>Nº de inscrição</th>
        <th>Nome Completo</th>
        <th>Deferido/Indeferido</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let r of dados.recursos">
        <td>{{ r.inscricaoId }}</td>
        <td>{{ r.nome | uppercase }}</td>
        <td>{{ r.resultado }}</td>
      </tr>
    </tbody>
  </table>

  <table *ngIf="dados.recursos.length > 0 && (tipoRecurso === 'RESULTADO_RECURSO_FASE1' || tipoRecurso === 'RESULTADO_RECURSO_FASE2')">
    <thead>
      <tr>
        <th>NÚMERO DE INSCRIÇÃO</th>
        <th>NOME DO(A) CANDIDATO(A)</th>
        <th>RESULTADO</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let r of dados.recursos; let i = index">
        <td>{{ r.inscricaoId }}</td>
        <td>{{ r.nome | uppercase }}</td>
        <td><textarea rows="2" class="cell-input" [(ngModel)]="dados.recursos[i].justificativa" (ngModelChange)="emitir()" (keydown.enter)="$event.stopPropagation()" placeholder="Deferido/Indeferido - Justificativa"></textarea></td>
      </tr>
    </tbody>
  </table>

  <div class="doc-footer">
    <p>Campinas,
      <mat-form-field appearance="outline" class="inline-field">
        <mat-label>Data</mat-label>
        <input matInput [(ngModel)]="campos['dataDocumento']" (ngModelChange)="onCampoChange('dataDocumento', $event)">
      </mat-form-field>.
    </p>
  </div>
</div>
